import { useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useAuthContext } from 'src/context/AuthContextProvider';
import OperationWalletTable from 'src/pages/Operation/OperationWalletTable';
import { convertNumber } from 'src/utils/number';

import { WalletPropertyRow } from '../types';

interface WalletPropertyProps {
  data: WalletPropertyRow[];
  isLoading: boolean;
}

export default function WalletProperty({
  data,
  isLoading,
}: WalletPropertyProps): JSX.Element | null {
  const { auth } = useAuthContext();

  const columns: MRT_ColumnDef<any>[] = useMemo(
    () => [
      {
        accessorKey: 'nomeImovel',
        accessorFn: (row) => row?.nomeImovel,
        header: 'Nome do imóvel',
        Cell: ({ cell }: { cell: any }) =>
          cell.getValue() ? cell.getValue() : '-',
      },
      {
        accessorKey: 'endereco',
        accessorFn: (row) => row?.endereco,
        header: 'Endereço',
        Cell: ({ cell }: { cell: any }) =>
          cell.getValue() ? cell.getValue() : '-',
      },
      {
        accessorKey: 'area',
        accessorFn: (row) => row?.area,
        header: 'Área (m²)',
        Cell: ({ cell }: { cell: any }) =>
          cell.getValue() ? cell.getValue() : '-',
      },
      {
        accessorKey: 'percentualVacancia',
        header: 'Percentual de Vacância',
        accessorFn: (row) => row.percentualVacancia,
        Cell: ({ cell }: { cell: any }) =>
          cell.getValue()
            ? `${convertNumber(cell.getValue() * 100, 3, 1)}%`
            : '-',
      },
      {
        accessorKey: 'percentualInadimplencia',
        header: 'Percentual de Inadimplência',
        accessorFn: (row) => row.percentualInadimplencia,
        Cell: ({ cell }: { cell: any }) =>
          cell.getValue()
            ? `${convertNumber(cell.getValue() * 100, 3, 1)}%`
            : '-',
      },
      {
        accessorKey: 'percentualReceitasFii',
        header: 'Percentual de Receitas',
        accessorFn: (row) => row.percentualReceitasFii,
        Cell: ({ cell }: { cell: any }) =>
          cell.getValue()
            ? `${convertNumber(cell.getValue() * 100, 3, 1)}%`
            : '-',
      },
    ],
    [],
  );

  const hasPermission =
    auth?.user?.subscription?.plan?.permissions?.operacoes_fii_ativo_carteira;

  if (!data.length) return null;

  return (
    <Box>
      <Typography
        sx={{
          fontSize: '20px',
          fontWeight: 600,
          lineHeight: '22px',
          marginLeft: 1,
        }}>
        Imóveis
      </Typography>
      <OperationWalletTable
        hasPermission={!!hasPermission}
        data={data}
        columns={columns}
        isLoading={isLoading}
      />
    </Box>
  );
}
